module.exports = __webpack_public_path__ + "static/media/humza icon-04-04.6b9da4f3.png";